"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarInteractiveItem = void 0;
var tslib_1 = require("tslib");
var toolbar_item_base_1 = require("./toolbar-item-base");
var ToolbarInteractiveItem = (function (_super) {
    tslib_1.__extends(ToolbarInteractiveItem, _super);
    function ToolbarInteractiveItem(options, onCommandExecuted) {
        var _this = _super.call(this) || this;
        _this.options = options;
        _this.onCommandExecuted = onCommandExecuted;
        _this.name = options.name;
        return _this;
    }
    ToolbarInteractiveItem.prototype.setEnabled = function (enabled) {
        this.widget.option('disabled', !enabled);
    };
    ToolbarInteractiveItem.prototype.setVisible = function (visible) {
        this.widget.option('visible', visible);
    };
    ToolbarInteractiveItem.prototype.getOnInitializedHandler = function () {
        var _this = this;
        return function (e) { return _this.applyWidget(e); };
    };
    ToolbarInteractiveItem.prototype.applyWidget = function (e) {
        this.widget = e.component;
    };
    return ToolbarInteractiveItem;
}(toolbar_item_base_1.ToolbarItemBase));
exports.ToolbarInteractiveItem = ToolbarInteractiveItem;
